import { Workspace } from '@/types/workspace';

/**
 * BOXY-360 — what a member IS in a workspace.
 *
 * `role` is only the membership tier (OWNER, or ADMIN for every other member),
 * so a member given a custom "limited" role read as "Admin". `role_names` is
 * the scoped role the server enforces; show it, and fall back to the tier only
 * when the server does not send it.
 */
export const workspaceRoleLabel = (
  workspace: Pick<Workspace, 'role' | 'role_names'> | null | undefined,
  t: (key: string) => unknown,
): string => {
  if (workspace?.role === 'OWNER') return String(t('workspace.role_owner'));

  const names = (workspace?.role_names ?? []).filter(Boolean);
  if (names.length === 0) return String(t('workspace.role_admin'));

  return names
    .map((name) => (name.toLowerCase() === 'admin' ? String(t('workspace.role_admin')) : name))
    .join(', ');
};
